import { defaultSort, IFilter, IAnswer, IQuestionInfo } from '@ugc-components/ugc-pdp-question-and-answer/interfaces';

interface IQnaState {
  isShowAskModal: boolean;
  isShowQnaFilterModal: boolean;
  isFirstAskQuestion: boolean;
  isShowAnswerModal: boolean;
  isShowViewMoreAnswersModal: boolean;

  textToSearch: string;
  sortId: number;
  cid: number;
  categoryList: Array<IFilter>;
  sorterList: Array<IFilter>;

  isQnaLoading: boolean;
  isQnaLoaded: boolean;
  isFirstLoad: boolean;
  qids: string[];
  questionBreakUpById: { [qid: string]: IQuestionInfo };
  qnaListTotalCount: number;
  qnaListStaticTotalCount: number;
  answeredList: Array<{
    questionId: string;
    isAnswered: boolean;
  }>;
  qnaStaticLanguage: {
    [key: string]: string;
  };

  answerModalData: {
    questionId: string;
  };
  viewMoreAnswersData: {
    questionId: string;
    nextPageToken: string;
    answersIdList: string[];
    answersDetail: {
      [key: string]: IAnswer;
    };
  };
}

const qna: IQnaState = {
  isShowAskModal: false,
  isFirstAskQuestion: false,
  isShowQnaFilterModal: false,
  isShowAnswerModal: false,
  isShowViewMoreAnswersModal: false,
  // filter
  textToSearch: '',
  sortId: defaultSort,
  cid: 0,
  categoryList: [],
  sorterList: [],
  // question list
  isQnaLoading: false,
  isQnaLoaded: false,
  isFirstLoad: true,
  qids: [],
  questionBreakUpById: {},
  qnaListTotalCount: 0,
  qnaListStaticTotalCount: 0,
  //qna cms data
  qnaStaticLanguage: {},
  answeredList: [],
  answerModalData: {
    questionId: '',
  },
  viewMoreAnswersData: {
    questionId: '',
    nextPageToken: '',
    answersIdList: [],
    answersDetail: {},
  },
};

export default qna;
